export default __webpack_public_path__ + "static/plp--story-1-731dd777ff37b0ab4b3bb1bdef2b0dbf.jpg";